<div class="d-flex align-items-center justify-content-between mb-3">
  <div class="card-sub-heading mr-2">
    Update the {{props.item.disease}} status as
    <strong>'{{ props.item.selectedStatusValue }}'?</strong>
  </div>
  <button mat-icon-button (click)="dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>
<form [formGroup]="form" (ngSubmit)="formSubmit()">
  <div class="row py-2" *ngIf="selectedStatus !== 11 && selectedStatus !== 12">
    <div class="col-md-12" *ngIf="isDiseaseId !== 5">
      
      <mat-checkbox
        class="example-margin bold mt-3 ml-3"
        (change)="onCheckChange($event)"
        formControlName="NotifyUsers"
      >
        Notify Users
      </mat-checkbox>

      <div class="row p-3" *ngIf="form.value.NotifyUsers">
        <div class="col-md-12">
          <div class="d-flex row py-3">
            <ng-container formArrayName="NotifyUsersBy">
              <ng-container
                *ngFor="let item of notifyByArray.controls; let i = index"
              >
                <ng-container [formGroupName]="i">
                  <div class="col-md-4">
                    <mat-checkbox
                      value="{{ item.value.id }}"
                      formControlName="isChecked"
                      >{{ item.value.value }}
                    </mat-checkbox>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <app-error-message
              [formName]="form"
              [fieldName]="'NotifyUsersBy'"
              [type]="'group'"
            >
            </app-error-message>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selectedStatus == '4' || selectedStatus == '6'" class="row mb-2">
    <div class="col-md-4">
      <mat-select
        formControlName="selectedLanguage"
        (selectionChange)="onLanguageChange($event)"
        class="form-control  w-100"
        placeholder="Language"
      >
        <mat-option value="en"> English </mat-option>
        <mat-option value="fr"> French </mat-option>
      </mat-select>
    </div>
    <div class="col-md-8">
      <mat-select
        formControlName="RejectedReasonID"
        class="form-control  w-100"
        placeholder="Select reason to cancel"
      >
        <mat-option *ngFor="let item of rejectedReason" [value]="item.id">
          {{ selectedLanguage == "en" ? item?.title_en : item?.title_fr }}
        </mat-option>
        <mat-option class="select-btn" (click)="openAddRasonDialog()">
          <div class="d-flex align-items-center">
            <span class="material-icons mr-2 add"> add </span> Add reason to
            cancel
          </div>
        </mat-option>
      </mat-select>
      <app-error-message
        [formName]="form"
        [fieldName]="'RejectedReasonID'"
        [type]="'group'"
      >
      </app-error-message>
    </div>
  </div>
  <div class="row py-2">
    <div class="col-md-12">
      <!-- <div class="card-sub-heading grey">User Last Login</div>
      <div class="mt-2">Mon, Aug 16, 2021 6:27</div> -->
    </div>
  </div>
<div *ngIf="isDiseaseId !== 5">
  <div class="row py-4" *ngIf="isCustomMessageVisible() && this.form.value.NotifyUsers" >
    <div class="col-md-12">
      <mat-checkbox
        class="example-margin"
        formControlName="custom_message"
        (change)="onCheckMessage($event)"
        >Custom Message</mat-checkbox
      >
    </div>
  </div>
  <div class="row" *ngIf="this.form.value.custom_message">
    <div class="col-md-12">
      <div class="form-group">
        <textarea
          class="form-control"
          formControlName="message"
          placeholder="Please enter cancellation reason... "
          rows="3"
        ></textarea>
        <mat-error
          class="ml-3"
          *ngIf="
            form.controls['message'].touched &&
            form.controls['message'].hasError('required')
          "
        >
          Message is required
        </mat-error>
      </div>
    </div>
  </div>
</div>


  <div class="row mt-4">
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <button class="custom-btn" (click)="coloseDilog()" type="button">
        Cancel
      </button>
      <button class="custom-btn" type="submit" [disabled]="form.invalid">
        Confirm
        <span class="whiteLoader" *ngIf="isLoading"></span>
      </button>
    </div>
  </div>
</form>
